import React from "react";
import styles from './index.module.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CountUp from "react-countup";

const Card = ({ place, icon, text, number }) => {
  return (
    <div className={`${styles.card} ${styles[place]}`}>
      <div className={styles.cardIcon}>
      <FontAwesomeIcon icon={icon} className={styles.cardIconImage} />
      </div>
      <div className={styles.cardContent}>
        <p className={styles.cardText}>{text}</p>
        <CountUp end={number} duration={2} separator="," className={styles.cardNumber} />
      </div>
    </div>
  );
};

export default Card;
